import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUserContext } from '../../context';
import { useApi } from '../../hooks/useApi';
import { Dialog, DialogBody, DialogFooter, DialogHeader, IconButton, Tooltip, Typography, Button, Card, CardBody, Checkbox, Menu, MenuHandler, MenuList, MenuItem } from '@material-tailwind/react';
import { ClockLoader } from 'react-spinners';
import { MdDelete } from 'react-icons/md';
import { IoIosAddCircleOutline, IoMdRemoveCircleOutline } from 'react-icons/io';
import { BiDotsVerticalRounded } from 'react-icons/bi';

export default function ViewCard() {
    const { cardNo } = useParams();
    const { getCheckInCard, getImageUrl, updateCheckInRooms, deletePayment, getAvailableRooms, getBookingsByMobile, completeBookingsById } = useApi();
    const { fetchAccessToken, defaultHotel, user, isAdmin, assignments } = useUserContext();
    const [isLoading, setIsLoading] = useState(false);
    const [checkInCard, setCheckInCard] = useState({});
    const [bookingType, setBookingType] = useState("");
    const [roomCategories, setRoomCategories] = useState([]);
    const [availableRooms, setAvailableRooms] = useState([]);
    const [isShowProofImage, setShowProofImage] = useState(false);
    const [showAddRoomPopup, setShowAddRoomPopup] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [unitDiscount, setUnitDiscount] = useState(0);
    const [checkInGuestName, setCheckInGuestName] = useState("");
    const [checkInGuestMobile, setCheckInGuestMobile] = useState("");
    const [category, setCategory] = useState("");
    const [capacityAdults, setCapacityAdults] = useState(0);
    const [capacityKids, setCapacityKids] = useState(0);
    const [extraBeds, setExtraBeds] = useState(0);
    const [roomNo, setRoomNo] = useState("");
    const [showAdvancedBooingExists, setShowAdvancedBooking] = useState(false);
    const [advancedBookingNumber, setAdvancedBookingNumber] = useState("");
    const [bookings, setBookings] = useState([]);
    const [selectedBookingItems, setSelectedBookingItems] = useState(new Set());
    const [movedBookingItems, setMovedBookingItems] = useState([]);

    let getCheckInCardInternal = async () => {
        if (cardNo && defaultHotel) {
            setIsLoading(true);
            try {
                const token = await fetchAccessToken();
                const data = await getCheckInCard(defaultHotel, cardNo, token);
                if (data && data.card) {
                    data.card.bookingType = data.card.bookingType || "Walk-In";
                    setBookingType(data.card.bookingType);
                    setCheckInCard(data);
                }
            }
            catch (ex) {
                alert("Something went wrong.");
            }
            finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        let getCheckInCardInternal = async (cardNo, hotelId) => {
            if (cardNo && hotelId) {
                setIsLoading(true);
                try {
                    const token = await fetchAccessToken();
                    const data = await getCheckInCard(hotelId, cardNo, token);
                    if (data && data.card) {
                        let totalDiscountTemp = 0;
                        let totalAmount = 0;
                        data.card.roomDetails.forEach(roomDetail => {
                            totalDiscountTemp += roomDetail.totalDays * roomDetail.unitDiscount || 0;
                            totalAmount += roomDetail.totalAmount;
                        });
                        data.card.totalAmount = totalAmount - totalDiscountTemp;
                        data.card.amountDue = data.card.totalAmount - data.card.amountReceived - data.card.discount;
                        data.card.bookingType = data.card.bookingType || "Walk-In";
                        setBookingType(data.card.bookingType);
                        setCheckInCard(data);
                        setTotalDiscount(totalDiscountTemp);
                    }
                    let freeRooms = await getAvailableRooms(hotelId, token);
                    setAvailableRooms(freeRooms);
                }
                catch (ex) {
                    alert("Something went wrong.");
                }
                finally {
                    setIsLoading(false);
                }
            }
        };
        if (defaultHotel) {
            let hotel = assignments?.hotels.find(hotel => hotel.id.toLowerCase() === defaultHotel.toLowerCase());
            setRoomCategories(hotel.roomTypes);
        }
        if (cardNo && defaultHotel) {
            getCheckInCardInternal(cardNo, defaultHotel);
        }

    }, [defaultHotel]);

    let handleUpdateCardInternal = async () => {
        const confirm = window.confirm("Do you want to update card?");
        if (confirm) {
            try {
                if (!areRoomNumbersUnique(checkInCard.card.roomDetails)) {
                    alert("The same room number cannot be selected more than once.");
                    return;
                }
                setIsLoading(true);
                const token = await fetchAccessToken();
                var newCheckIns = [];
                checkInCard.card.roomDetails.forEach((roomDetail, index) => {
                    if (roomDetail.isNew) {
                        var newCheckIn = {
                            hotelId: defaultHotel,
                            roomNo: roomDetail.roomNo,
                            checkInEpoch: getEpochDateTimeString(roomDetail.checkInDateTime, index + 1),
                            checkOutEpoch: getEpochDateTimeString(roomDetail.checkOutDateTime, index + 1),
                            checkInDateTime: roomDetail.checkInDateTime,
                            checkOutDateTime: roomDetail.checkOutDateTime,
                            cardNo: checkInCard.card.cardNo,
                            guestName: roomDetail.guestName || checkInCard.card.guestName,
                            guestMobile: roomDetail.guestMobile || checkInCard.card.guestMobile,
                            manager: user.name,
                            bookingType: checkInCard.card.bookingType,
                            category: roomDetail.category
                        };
                        checkInCard.checkIns.push(newCheckIn);
                        newCheckIns.push(newCheckIn);
                    }
                });
                checkInCard.card.bookingType = bookingType || checkInCard.card.bookingType;
                checkInCard.checkIns.forEach(checkIn => {
                    checkIn.bookingType = checkInCard.card.bookingType;
                });
                let updateCheckInCard = { card: checkInCard.card, checkIns: checkInCard.checkIns, newCheckIns: newCheckIns };
                await updateCheckInRooms(defaultHotel, cardNo, updateCheckInCard, token);
                await Promise.all(movedBookingItems.map(async booking => {
                    try {
                        await completeBookingsById(defaultHotel, booking.guestMobile, booking.bookingId, "CONFIRMED", token);
                    } catch (ex) {
                        console.error(`Error completing booking: ${booking.bookingId}`, ex);
                    }
                }));
                alert("Card updated successfully.");
                window.location.reload();
            }
            catch (ex) {
                alert("Something went wrong.");
                window.location.reload();
            }
            finally {
                setIsLoading(false);
            }
        }
    };

    function areRoomNumbersUnique(roomDetails) {
        const roomNumbers = new Set();
        for (const roomDetail of roomDetails) {
            if (!roomDetail.isNew) {
                continue;
            }
            if (roomDetail.roomNo !== "" && roomNumbers.has(roomDetail.roomNo)) {
                return false;
            }
            roomNumbers.add(roomDetail.roomNo);
        }
        return true;
    }

    function getEpochDateTimeString(dateString, seconds) {
        const [day1, month1, year1, hour1, minute1] = dateString.split(/[\s:-]/);
        const date1 = new Date(year1, month1 - 1, day1, hour1 || 0, minute1 || 0, seconds, seconds * 100);
        return date1.getTime();
    }

    function epochToString(epoch) {
        const date = new Date(epoch);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');

        const dateString = `${day}-${month}-${year} ${hour}:${minute}`;

        return dateString;
    }

    let handleProofView = async (documentS3Id) => {
        try {
            setIsLoading(true);
            const token = await fetchAccessToken();
            const imageUrl = await getImageUrl(documentS3Id, token);
            if (imageUrl) {
                setImageUrl(imageUrl);
                setShowProofImage(true);
            }
        } catch (ex) {
            alert("Error occurred while viewing the Proof.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeletePayment_v2 = async (paymentDetail) => {
        if (checkInCard && checkInCard.card && checkInCard.checkIns && paymentDetail && paymentDetail.paymentDateTime) {
            if (paymentDetail.isNew) {
                const { card, checkIns } = checkInCard;
                const updatedCard = {
                    ...card,
                    paymentDetails: card.paymentDetails.filter(pd => pd.paymentDateTime !== paymentDetail.paymentDateTime)
                };
                const paymentReceived = updatedCard.paymentDetails.reduce((accumulator, current) => {
                    return accumulator + current.paymentAmount;
                }, 0);
                updatedCard.amountReceived = paymentReceived;
                updatedCard.amountDue = updatedCard.totalAmount - updatedCard.amountReceived;
                setCheckInCard({ checkIns, card: updatedCard });
                if (paymentDetail.advanceBookingId > 0) {
                    setMovedBookingItems(prev => prev.filter(b => b.bookingId !== paymentDetail.advanceBookingId));
                }
            }
            else {
                let confirm = window.confirm("Do you want to delete an existing payment?");
                if (confirm) {
                    setIsLoading(true);
                    try {
                        const token = await fetchAccessToken();
                        await deletePayment(defaultHotel, cardNo, paymentDetail.paymentDateTime, token);

                    } catch (ex) {
                        alert("Error deleting existing payment.");
                    }
                    finally {
                        setIsLoading(false);
                    }
                    await getCheckInCardInternal();
                }
            }

        }
    };

    function OptionsGenerator(n) {
        const options = [];
        for (let i = 1; i <= n; i++) {
            options.push(<option key={i} value={i}>{i}</option>);
        }

        return options;
    }

    let handleAddRoom = () => {
        setShowAddRoomPopup(true);
    };

    let cancelRoomAddPopup = () => {
        setRoomNo("");
        setCategory("");
        setCheckInGuestName("");
        setCheckInGuestMobile("");
        setCapacityAdults(0);
        setCapacityKids(0);
        setExtraBeds(0);
        setUnitDiscount(0);
        setShowAddRoomPopup(false);
    }

    let handleRoomAddPopup = () => {
        if (!roomNo || !category || !capacityAdults || !checkInCard || !checkInCard.card) {
            return;
        }
        const { card } = checkInCard;
        if (card.bookingType.startsWith("GB") && (!checkInGuestName || !checkInGuestMobile)) {
            alert("Please enter checkIn guest details.");
            return;
        }
        const { roomDetails } = card;
        const rc = getRoomDetailsByCategory(category);
        const totalDays = 1;
        const fare = totalDays * rc.price;
        const extraBedCost = totalDays * extraBeds * rc.extraBedCharges;
        const gst = ((totalDays * rc.price) + extraBedCost) * (rc.gst / 100);
        const totalCost = fare + extraBedCost + gst;
        let checkInDateTimeTemp = combineDateAndTime(getCurrentDate(), getCurrentTime());
        let checkOutDateTimeTemp = combineDateAndTime(getCurrentDate(23), getCurrentTime(-1));
        if (checkInCard.card.bookingType === "GB (Same Time CheckIn)") {
            if (roomDetails[0]) {
                checkInDateTimeTemp = roomDetails[0].checkInDateTime;
                checkOutDateTimeTemp = roomDetails[0].checkOutDateTime;
            }
        }
        const newRoomDetail = {
            roomNo: roomNo,
            checkInDateTime: checkInDateTimeTemp,
            checkOutDateTime: checkOutDateTimeTemp,
            totalDays: totalDays,
            totalAmount: totalCost,
            category: category,
            fare: rc.price,
            unitFare: rc.price,
            unitDiscount: unitDiscount,
            gst: gst,
            extraBedCost: extraBedCost,
            adults: capacityAdults,
            kids: capacityKids,
            extraBeds: extraBeds,
            gracePeriod: 0,
            isNew: true,
            guestName: checkInGuestName || '',
            guestMobile: checkInGuestMobile || '',
        };
        let totalDiscountTemp = 0;
        let totalAmount = 0;
        const updatedRoomDetails = [...roomDetails, newRoomDetail];
        updatedRoomDetails.forEach(function (rd) {
            const differenceDays = getDateDifference(rd.checkInDateTime, rd.checkOutDateTime, rd.gracePeriod || 0);
            totalAmount += rd.totalAmount;
            totalDiscountTemp += differenceDays * rd.unitDiscount;
        });
        card.totalAmount = totalAmount - totalDiscountTemp;
        card.amountDue = card.totalAmount - card.amountReceived - card.discount;
        setCheckInCard({
            ...checkInCard, card: {
                ...checkInCard.card, roomDetails: updatedRoomDetails
            },
        });
        setTotalDiscount(totalDiscountTemp);
        setShowAddRoomPopup(false);
        cancelRoomAddPopup();
    }


    function getDateDifference(dateString1, dateString2, gracePeriod = 0) {
        const [day1, month1, year1, hour1, minute1] = dateString1.split(/[\s:-]/);
        const [day2, month2, year2, hour2, minute2] = dateString2.split(/[\s:-]/);

        const date1 = new Date(year1, month1 - 1, day1, hour1 || 0, minute1 || 0);
        const date2 = new Date(year2, month2 - 1, day2, hour2 || 0, minute2 || 0);

        date2.setHours(date2.getHours() - gracePeriod);

        const differenceMs = Math.abs(date2 - date1);

        const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

        if (differenceDays === 0) {
            return 1;
        } else {
            return differenceDays;
        }
    }

    function getCurrentDate(hoursAdd = 0) {
        let d = new Date();
        d.setHours(d.getHours() + hoursAdd);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    }

    function getCurrentTime(hoursAdd = 0) {
        const now = new Date();
        now.setHours(now.getHours() + hoursAdd);
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return hours + ':' + minutes;
    }

    function combineDateAndTime(date, time) {
        const [hours, minutes] = time.split(':').map(Number);
        const combinedDate = new Date(date);
        combinedDate.setHours(hours);
        combinedDate.setMinutes(minutes);

        const formattedDateTime = `${combinedDate.getDate().toString().padStart(2, '0')}-${(combinedDate.getMonth() + 1).toString().padStart(2, '0')}-${combinedDate.getFullYear()} ${combinedDate.getHours().toString().padStart(2, '0')}:${combinedDate.getMinutes().toString().padStart(2, '0')}`;
        return formattedDateTime;
    }


    function getRoomDetailsByCategory(category) {
        const rc = roomCategories.find(rc => rc.category === category);
        return rc;
    }


    let handleDeleteRoom = (index) => {
        const { card } = checkInCard;
        const { roomDetails } = card;
        const updatedRoomDetails = [...roomDetails];
        updatedRoomDetails.splice(index, 1);
        let totalDiscountTemp = 0;
        let totalAmount = 0;
        updatedRoomDetails.forEach(function (rd) {
            const differenceDays = getDateDifference(rd.checkInDateTime, rd.checkOutDateTime, rd.gracePeriod || 0);
            totalAmount += rd.totalAmount;
            totalDiscountTemp += differenceDays * rd.unitDiscount;
        });
        card.totalAmount = totalAmount - totalDiscountTemp;
        card.amountDue = card.totalAmount - card.amountReceived - card.discount;
        setCheckInCard({
            ...checkInCard, card: {
                ...checkInCard.card, roomDetails: updatedRoomDetails
            },
        });
        setTotalDiscount(totalDiscountTemp);
    }

    async function getBookingsByMobileInternal() {
        if (advancedBookingNumber && defaultHotel) {
            setIsLoading(true);
            try {
                const token = await fetchAccessToken();
                let bookings = await getBookingsByMobile(defaultHotel, advancedBookingNumber, "CONFIRMED", token);
                if (bookings && bookings.length) {
                    setBookings(bookings);
                } else {
                    setBookings([]);
                }
            } catch (ex) {

            } finally {
                setIsLoading(false);
            }
        }
    }

    const handleCheckboxChange1 = (bookingId) => {
        setSelectedBookingItems(prev => {
            const newSelectedItems = new Set(prev);
            if (newSelectedItems.has(bookingId)) {
                newSelectedItems.delete(bookingId);
            } else {
                newSelectedItems.add(bookingId);
            }
            return newSelectedItems;
        });
    };

    const handleCloseAdvancedPaymentsPopup = () => {
        setShowAdvancedBooking(false);
        setAdvancedBookingNumber("");
        setBookings([]);
        setSelectedBookingItems(new Set());
    };

    const handleSelectAdvancedPayments = () => {
        const bookingIds = Array.from(selectedBookingItems);
        if (bookingIds.length > 0) {
            let incomeDateTime = Date.now();
            let paymentDetailsTemp = [];
            let bookingAttachmentsTemp = [];
            let tempMovedBookings = [];
            for (let i = 0; i < bookingIds.length; i++) {
                let booking = bookings.find(b => b.bookingId === bookingIds[i]);
                if (booking) {
                    let paymentDetail = {}
                    paymentDetail.paymentMode = booking.paymentMode;
                    paymentDetail.paymentAmount = booking.advancePayment;
                    paymentDetail.paymentDateTime = incomeDateTime + i + 1;
                    paymentDetail.remarks = `Advance Payment ${booking.advancePayment} received from ${booking.guestName} on ${booking.paymentDate} via ${booking.paymentMode}`;
                    paymentDetail.isNew = true;
                    paymentDetail.advanceBookingId = bookingIds[i];
                    paymentDetailsTemp.push(paymentDetail);
                    bookingAttachmentsTemp = [...bookingAttachmentsTemp, ...booking.documentS3Ids];
                    tempMovedBookings.push(booking);
                }
            }
            const { card, checkIns } = checkInCard;
            const updatedCard = {
                ...card, documentS3Ids: [...card.documentS3Ids, ...bookingAttachmentsTemp],
                paymentDetails: [...card.paymentDetails, ...paymentDetailsTemp]
            };
            const paymentReceived = updatedCard.paymentDetails.reduce((accumulator, current) => {
                return accumulator + current.paymentAmount;
            }, 0);
            updatedCard.amountReceived = paymentReceived;
            updatedCard.amountDue = updatedCard.totalAmount - updatedCard.amountReceived;
            setCheckInCard({ checkIns, card: updatedCard });
            setMovedBookingItems([...movedBookingItems, ...tempMovedBookings]);
        }
        handleCloseAdvancedPaymentsPopup();
    };

    function getExtrabedCost(roomDetail) {
        const rc = getRoomDetailsByCategory(roomDetail.category);
        return roomDetail.totalDays * roomDetail.extraBeds * rc.extraBedCharges
    }

    function canBeUsed(booking) {
        if (isAdmin) {
            return true;
        }
        const now = Date.now();
        const FIVE_HOURS = 5 * 60 * 60 * 1000;
        return now >= booking.checkInEpoch - FIVE_HOURS && now <= booking.checkOutEpoch;
    }

    return (
        <div>
            <section className="py-1 bg-blueGray-50">
                <div className="w-full lg:w-10/12 px-4 mx-auto mt-6">
                    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
                        <div className="rounded-t bg-white mb-0 px-6 py-6">
                            <div className="text-center flex justify-between">
                                <h6 className="text-blueGray-700 text-xl font-normal">
                                    Card # {" "} {cardNo}
                                </h6>
                            </div>
                        </div>
                        {checkInCard && checkInCard.card &&
                            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                <div className="flex flex-wrap mt-3">
                                    <div className="flex flex-row w-full mb-3 px-4">
                                        <div className="relative w-full mb-3">
                                            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                Guest Mobile<span className="text-red-500">*</span>
                                            </label>
                                            <input type="tel" id="guestMobile" name="guestMobile" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-grey rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                value={checkInCard.card.guestMobile} disabled={true} readOnly={true} />
                                        </div>
                                        <div className="relative w-full mb-3 ml-3">
                                            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                Guest Name<span className="text-red-500">*</span>
                                            </label>
                                            <input type="text" id="guestName" name="guestName" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-grey rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                disabled={true} value={checkInCard.card.guestName} readOnly={true} />
                                        </div>
                                    </div>
                                    {checkInCard.card.status === "ACTIVE" ?
                                        <div className="w-full px-4 mb-3">
                                            <label className="inline-flex items-center cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    id="guestVehicle"
                                                    name="guestVehicle"
                                                    checked={checkInCard.card.guestVehicle || false}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setCheckInCard({
                                                            ...checkInCard,
                                                            card: {
                                                                ...checkInCard.card,
                                                                guestVehicle: checked,
                                                                vehicleType: checked ? checkInCard.card.vehicleType : "",
                                                                vehicleNumber: checked ? checkInCard.card.vehicleNumber : ""
                                                            }
                                                        });
                                                    }}
                                                />
                                                <span className="ml-2 uppercase text-blueGray-600 text-xs font-bold">Guest has a vehicle</span>
                                            </label>
                                            {checkInCard.card.guestVehicle &&
                                                <div className="flex flex-row w-full mt-3">
                                                    <div className="relative w-full mb-3">
                                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                            Vehicle Type
                                                        </label>
                                                        <select label="Vehicle Type" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-3 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                                            name="vehicleType" id="vehicleType"
                                                            value={checkInCard.card.vehicleType || ""}
                                                            onChange={(e) => setCheckInCard({ ...checkInCard, card: { ...checkInCard.card, vehicleType: e.target.value } })}>
                                                            <option key="" value="">Select</option>
                                                            <option key="2 Wheeler" value="2 Wheeler">2 Wheeler</option>
                                                            <option key="Car" value="Car">Car</option>
                                                            <option key="Transport" value="Transport">Transport</option>
                                                            <option key="Other" value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                    <div className="relative w-full mb-3 ml-3">
                                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                            Vehicle Number
                                                        </label>
                                                        <input type="text" id="vehicleNumber" name="vehicleNumber" className="uppercase border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={checkInCard.card.vehicleNumber || ""} placeholder="e.g. AP12AB1234"
                                                            onChange={(e) => setCheckInCard({ ...checkInCard, card: { ...checkInCard.card, vehicleNumber: e.target.value } })} />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        :
                                        (checkInCard.card.guestVehicle || checkInCard.card.vehicleNumber) &&
                                        <div className="flex flex-row w-full mb-3 px-4">
                                            <div className="relative w-full mb-3">
                                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                    Vehicle Type
                                                </label>
                                                <input type="text" id="vehicleType" name="vehicleType" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-grey rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                    value={checkInCard.card.vehicleType} disabled={true} readOnly={true} />
                                            </div>
                                            <div className="relative w-full mb-3 ml-3">
                                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                    Vehicle Number
                                                </label>
                                                <input type="text" id="vehicleNumber" name="vehicleNumber" className="uppercase border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-grey rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                    value={checkInCard.card.vehicleNumber} disabled={true} readOnly={true} />
                                            </div>
                                        </div>
                                    }
                                    <div className="flex flex-row w-full mb-3 px-4">
                                        <div className="flex flex-row w-full lg:w-4/12 px-4">
                                            <div className="relative w-full mb-3">
                                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                    Card Status
                                                </label>
                                                <Typography
                                                    variant="small"
                                                    className="flex items-center font-normal text-blue-gray-600"
                                                >
                                                    {checkInCard.card.status}
                                                </Typography>
                                            </div>
                                            <div className="relative w-full mb-3">
                                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                    Booking Type
                                                </label>
                                                <select label="Booking Type" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-3 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                                    name="bookingType" id="bookingType"
                                                    onChange={(event) => setBookingType(event.target.value)}
                                                    value={bookingType} disabled={!isAdmin}>
                                                    <option key="" value="">Select</option>
                                                    <option key="Walk-In" value="Walk-In">Walk-In</option>
                                                    <option key="Online" value="Online">Online</option>
                                                    <option key="Free" value="Free">Free</option>
                                                    <option key="Couple" value="Couple">Couple</option>
                                                    <option key="GB (Same Time CheckIn)" value="GB (Same Time CheckIn)">GB (Same Time CheckIn)</option>
                                                    <option key="GB (Diff Time CheckIn)" value="GB (Diff Time CheckIn)">GB (Different Time CheckIn)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full lg:w-12/12 px-4 overflow-scroll">
                                        <div className="relative w-full mb-3">
                                            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                Room Details
                                            </label>
                                            <div className="w-full lg:w-12/12 px-1  py-0 flex justify-end ">
                                                {checkInCard.card.status === "ACTIVE" && <IconButton color="green" onClick={handleAddRoom}>
                                                    <IoIosAddCircleOutline className="w-5 h-5" />
                                                </IconButton>}
                                            </div>
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                                                {checkInCard.card.roomDetails.map((roomDetail, index) => (
                                                    <Card
                                                        key={index}
                                                        className={`shadow-md rounded-lg ${roomDetail.closed ? "line-through text-gray-500" : ""}`}
                                                    >
                                                        <CardBody className="px-3 py-1">
                                                            {isAdmin && <div className="flex justify-end">
                                                                <Menu>
                                                                    <MenuHandler>
                                                                        <IconButton variant="text">
                                                                            <BiDotsVerticalRounded className="h-6 w-6" />
                                                                        </IconButton>
                                                                    </MenuHandler>
                                                                    <MenuList className="flex flex-col gap-2">
                                                                        <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8" onClick={() => alert("Test In Progress")}>
                                                                            <div className="flex flex-col gap-1">
                                                                                <Typography variant="small" color="gray" className="font-semibold">
                                                                                    Edit
                                                                                </Typography>
                                                                            </div>
                                                                        </MenuItem>
                                                                    </MenuList>
                                                                </Menu>
                                                            </div>
                                                            }
                                                            <div className="text-gray-900">Room No: {roomDetail.roomNo}</div>
                                                            <div className="text-gray-900">Type: {roomDetail.category}</div>
                                                            <div className="text-gray-900">Extra beds: {roomDetail.extraBeds || 0}</div>
                                                            <div className="text-gray-900">Check-In: {roomDetail.checkInDateTime}</div>
                                                            <div className="text-gray-900">Check-Out: {roomDetail.checkOutDateTime}</div>
                                                            <div className="text-gray-900">Today Days: {roomDetail.totalDays}</div>
                                                            <div className="text-gray-900">Totoal Amount: {roomDetail.totalAmount}.00</div>
                                                            <div className="text-gray-900">(Fare:{roomDetail.fare || 0}.00 + EB:{roomDetail.extraBedCost || getExtrabedCost(roomDetail)}.00 + GST:{roomDetail.gst > 0 ? roomDetail.gst + ".00" : "Incl."})</div>
                                                            <div className="text-gray-900">Total Discount: {roomDetail.unitDiscount * roomDetail.totalDays}.00 ({roomDetail.unitDiscount}.00 X {roomDetail.totalDays}D)</div>
                                                            {roomDetail.guestName && (
                                                                <div className="text-gray-900">Guest Name: {roomDetail.guestName}</div>
                                                            )}
                                                            {roomDetail.isNew && (
                                                                <IconButton color="red" className="mr-3 mt-9"
                                                                    onClick={() => handleDeleteRoom(index)}>
                                                                    <IoMdRemoveCircleOutline className="w-5 h-5" />
                                                                </IconButton>
                                                            )}
                                                        </CardBody>
                                                    </Card>
                                                ))}
                                            </div>
                                            <table className="min-w-full divide-y divide-gray-200 bg-white shadow overflow-hidden rounded-lg">
                                                <tr className="bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-right" >Total Amount</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">{checkInCard.card.totalAmount + totalDiscount}.00</td>
                                                </tr>
                                                <tr className="bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-right" >Discount</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">{totalDiscount}.00</td>
                                                </tr>
                                                <tr className="bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-right" >Net Amount</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">{checkInCard.card.totalAmount}.00</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="w-full lg:w-12/12 px-4 overflow-scroll">
                                        <div className="relative w-full mb-3">
                                            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                Payment Details
                                            </label>
                                            <div className="w-full lg:w-12/12 px-1  py-1 mb-1 flex justify-end ">
                                                {checkInCard && checkInCard.card && checkInCard && checkInCard.card.status === "ACTIVE" && <button onClick={() => setShowAdvancedBooking(true)} className="px-3 py-1 ml-2 bg-purple-400 rounded hover:bg-purple-600 text-white">
                                                    Add Advanced Booking Payments
                                                </button>}
                                            </div>
                                            <table className="min-w-full divide-y divide-gray-200 bg-white shadow overflow-hidden rounded-lg">
                                                <thead className="bg-gray-50">
                                                    <tr>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mode</th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {checkInCard.card.paymentDetails.map((paymentDetail, i) =>
                                                        <tr className={`${paymentDetail.isNew ? "bg-blue-200" : ""}`}>
                                                            <td className="px-6 py-4 whitespace-nowrap text-gray-700">{epochToString(paymentDetail.paymentDateTime)}</td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-gray-700">{paymentDetail.paymentMode}</td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-gray-700">{paymentDetail.paymentAmount}.00</td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                                                                {isAdmin && checkInCard.card.status === "ACTIVE" && <Tooltip content="Delete">
                                                                    <IconButton variant="text" onClick={() => handleDeletePayment_v2(paymentDetail)}>
                                                                        <MdDelete className="h-6 w-6" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )}
                                                    <tr className="bg-gray-50">
                                                        <td className="px-6 py-4 whitespace-nowrap text-right" colSpan={2} >Amount Received</td>
                                                        <td className="px-6 py-4 whitespace-nowrap">{checkInCard.card.amountReceived}.00</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr className="bg-gray-50">
                                                        <td className="px-6 py-4 whitespace-nowrap text-right" colSpan={2} >Balance Due</td>
                                                        <td className="px-6 py-4 whitespace-nowrap">{checkInCard.card.amountDue}.00</td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="flex flex-wrap">
                                            <div className="relative w-full mb-3">
                                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" >
                                                    Payment proofs
                                                </label>
                                                <div className="flex flex-col">
                                                    <div className="relative w-full px-5">
                                                        <ul>
                                                            {checkInCard.card.documentS3Ids.map((s3Id, i) => <li className="cursor-pointer"><u key={i} onClick={() => handleProofView(s3Id)}>{"Payment Proof "} {i + 1}</u></li>)}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="w-full flex justify-end  mb-0 px-6 py-6">
                            {checkInCard && checkInCard.card && checkInCard.card.status === "ACTIVE" &&
                                <button className="bg-green-500 text-white hover:bg-green-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-2 ease-linear transition-all duration-150" type="button"
                                    onClick={handleUpdateCardInternal}>
                                    Update Card
                                </button>
                            }
                        </div>
                    </div>

                </div>
            </section>
            <Dialog size={"xs"} open={isShowProofImage}>
                <DialogHeader className="flex justify-end items-center h-full">
                    <Button
                        variant="text"
                        color="red"
                        onClick={() => setShowProofImage(false)}
                        className="mr-1"
                    >
                        <span>Close</span>
                    </Button>
                </DialogHeader>
                <DialogBody>
                    <img src={imageUrl} />
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="text"
                        color="red"
                        onClick={() => setShowProofImage(false)}
                        className="mr-1"
                    >
                        <span>Close</span>
                    </Button>
                </DialogFooter>
            </Dialog>
            <Dialog size={"xs"} open={showAddRoomPopup} className="max-h-screen overflow-y-auto z-50">
                <DialogHeader className="flex flex-start h-full">
                    Add Room
                </DialogHeader>
                <DialogBody className="max-h-[80vh] overflow-y-auto">
                    <div className="flex flex-wrap border border-gray-300 p-2">
                        <div className="w-50 mr-3 mt-3 mb-3">
                            <label htmlFor={`roomNo`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Room<span className="text-red-500">*</span></label>
                            <select label="Room" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                name={`roomNo`} id={`roomNo`}
                                onChange={(event) => setRoomNo(event.target.value)}
                                value={roomNo}>
                                <option value="">Select</option>
                                {availableRooms.sort((a, b) => a.roomNo.localeCompare(b.roomNo)).map((room, i) => (
                                    <option key={i} value={room.roomNo}>{room.roomNo}</option>
                                ))}
                            </select>
                        </div>
                        <div className="w-50 mr-3 mt-3 mb-3">
                            <label htmlFor={`category`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Category Room<span className="text-red-500">*</span></label>
                            <select label="Category" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                name={`category`} id={`category`}
                                onChange={(event) => setCategory(event.target.value)}
                                value={category}>
                                <option value="">Select</option>
                                {roomCategories.map((category, i) => (
                                    <option key={i} value={category.category}>{category.category}</option>
                                ))}
                            </select>
                        </div>
                        <div className="w-50 mr-3 mt-3 mb-3">
                            <label htmlFor={`capacity_adults`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Adults<span className="text-red-500">*</span></label>
                            <select label="Adults" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                name={`capacity_adults`} id={`capacity_adults`}
                                onChange={(e) => setCapacityAdults(parseInt(e.target.value))}
                                value={capacityAdults}>
                                <option value={0}>Select</option>
                                {roomCategories.find(rc => rc.category === category) &&
                                    OptionsGenerator(roomCategories.find(rc => rc.category === category).capacity.adults)
                                }
                            </select>
                        </div>
                        <div className="w-50 mr-3 mt-3 mb-3">
                            <label htmlFor={`capacity_kids`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Kids</label>
                            <select label="Kids" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                name={`capacity_kids`} id={`capacity_kids`}
                                onChange={(e) => setCapacityKids(parseInt(e.target.value))}
                                value={capacityKids}>
                                <option value={0}>Select</option>
                                {roomCategories.find(rc => rc.category === category) &&
                                    OptionsGenerator(roomCategories.find(rc => rc.category === category).capacity.kids)
                                }
                            </select>
                        </div>
                        <div className="w-50 mr-3 mt-3 mb-3">
                            <label htmlFor={`extraBeds`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Extra Beds</label>
                            <select label="Extra Beds" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                name={`extraBeds`} id={`extraBeds`}
                                onChange={(e) => setExtraBeds(parseInt(e.target.value))}
                                value={extraBeds}>
                                <option key={0} value={0}>Select</option>
                                <option key={1} value={1}>1</option>
                                <option key={2} value={2}>2</option>
                                <option key={3} value={3}>3</option>
                            </select>
                        </div>
                        <div className="w-50 mr-3 mt-3 mb-3">
                            <label htmlFor={`unitDiscount`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Discount(Per Day)</label>
                            <input type="number" id={`unitDiscount`} name={`unitDiscount`}
                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                value={unitDiscount} onChange={(e) => setUnitDiscount(parseInt(e.target.value))} />
                        </div>
                        {
                            checkInCard && checkInCard.card && checkInCard.card.bookingType.startsWith("GB") &&
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor={`checkInGuestName`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Guest Name<span className="text-red-500">*</span></label>
                                <input type="text" id={`checkInGuestName`} name={`checkInGuestName`}
                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={checkInGuestName} onChange={(e) => setCheckInGuestName(e.target.value)} />
                            </div>
                        }
                        {
                            checkInCard && checkInCard.card && checkInCard.card.bookingType.startsWith("GB") &&
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor={`checkInGuestMobile`} className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Guest Mobile<span className="text-red-500">*</span></label>
                                <input type="tel" id={`checkInGuestMobile`} name={`checkInGuestMobile`}
                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={checkInGuestMobile} onChange={(e) => setCheckInGuestMobile(e.target.value)} />
                            </div>
                        }
                    </div>
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="text"
                        color="red"
                        onClick={(e) => cancelRoomAddPopup()}
                        className="mr-1"
                    >
                        <span>Close</span>
                    </Button>
                    <Button
                        variant="text"
                        color="blue"
                        onClick={(e) => handleRoomAddPopup()}
                        className="mr-1"
                    >
                        <span>Add</span>
                    </Button>
                </DialogFooter>
            </Dialog>
            <Dialog size={"xs"} open={showAdvancedBooingExists} className="max-h-screen overflow-y-auto z-50">
                <DialogHeader className="flex flex-start h-full">
                    Advanced Booking Payments
                </DialogHeader>
                <DialogBody className="max-h-[80vh] overflow-y-auto">
                    <div>
                        <div className="w-50 mt-3 mb-3">
                            <label htmlFor="amount" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Guest Mobile</label>
                            <input type="tel" id="guestMobile" name="guestMobile" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                value={advancedBookingNumber} onChange={(e) => setAdvancedBookingNumber(e.target.value)} placeholder="Enter guest mobile number" />

                            <Button className="rounded-full mt-2" size="sm" onClick={getBookingsByMobileInternal}>Search</Button>
                        </div>
                        <div className="w-50 mt-3 mb-3 flex flex-col">
                            {bookings.filter(booking => booking.advancePayment > 0).map((booking, index) => (
                                <div key={index} className="flex items-center mb-2">
                                    <Checkbox
                                        checked={selectedBookingItems.has(booking.bookingId)}
                                        onChange={() => handleCheckboxChange1(booking.bookingId)} disabled={!canBeUsed(booking)}
                                    />
                                    <Typography variant="h6" className="ml-2">
                                        Booking start: {booking.checkInDateTime}
                                    </Typography>
                                    <Typography variant="h6" className="ml-2">
                                        Booking end:  {booking.checkOutDateTime}
                                    </Typography> <Typography variant="small" className="ml-2">
                                        {booking.guestName} - {booking.bookingStatus} - {booking.advancePayment}.00
                                    </Typography>
                                </div>
                            ))}
                        </div>
                    </div>
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="text"
                        color="red"
                        onClick={(e) => handleCloseAdvancedPaymentsPopup()}
                        className="mr-1"
                    >
                        <span>Close</span>
                    </Button>
                    <Button
                        variant="text"
                        color="blue"
                        onClick={(e) => handleSelectAdvancedPayments()}
                        className="mr-1"
                    >
                        <span>Move Payments</span>
                    </Button>
                </DialogFooter>
            </Dialog>
            <Dialog open={isLoading} className="bg-transparent shadow-none z-60" size="md">
                <DialogBody className="bg-transparent shadow-none flex justify-center">
                    <ClockLoader color="#2be60d" />
                </DialogBody>
            </Dialog>
        </div>
    );
}